var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B4CCDD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,20.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,20.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,20.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,32.2c-0.1-0.6-0.2-1.1-0.4-1.6c-0.2-0.5-0.4-0.9-0.6-1.4c-0.3-0.5-0.6-0.8-0.9-1.2 c-0.3-0.3-0.7-0.6-1.2-0.8c-0.5-0.2-1-0.3-1.6-0.3c-0.1,0-0.3,0.1-0.6,0.3c-0.3,0.2-0.7,0.4-1,0.7c-0.4,0.3-0.9,0.5-1.5,0.7 c-0.6,0.2-1.3,0.3-1.9,0.3c-0.6,0-1.3-0.1-1.9-0.3c-0.6-0.2-1.2-0.4-1.5-0.7c-0.4-0.3-0.7-0.5-1-0.7c-0.3-0.2-0.5-0.3-0.6-0.3 c-0.6,0-1.1,0.1-1.6,0.3c-0.5,0.2-0.9,0.4-1.2,0.8c-0.3,0.3-0.6,0.7-0.9,1.2c-0.3,0.5-0.5,0.9-0.6,1.4c-0.2,0.5-0.3,1-0.4,1.6 c-0.1,0.6-0.2,1.1-0.2,1.6c0,0.5,0,1,0,1.5c0,1.1,0.3,2,1,2.7c0.7,0.7,1.6,1,2.8,1h12.5c1.2,0,2.1-0.3,2.8-1c0.7-0.7,1-1.6,1-2.7 c0-0.5,0-1,0-1.5C34.1,33.3,34,32.8,33.9,32.2L33.9,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,32.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.8,26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,26.4c1.1,1.1,2.4,1.6,3.9,1.6c1.5,0,2.8-0.5,3.9-1.6c1.1-1.1,1.6-2.4,1.6-3.9c0-1.5-0.5-2.8-1.6-3.9 c-1.1-1.1-2.4-1.6-3.9-1.6c-1.5,0-2.8,0.5-3.9,1.6c-1.1,1.1-1.6,2.4-1.6,3.9C18.6,24,19.1,25.3,20.2,26.4L20.2,26.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDefault);
export default __webpack_public_path__ + "static/media/users-default.1542d9dda264185c38358217d3eb27ff.svg";
export { ForwardRef as ReactComponent };